import dollar from './Dollar'
import euro from './Euro'
import franc from './Franc'
import krona from './Krona'
import lira from './Lira'
import multiCurrency from './MultiCurrency'
import peso from './Peso'
import pound from './Pound'
import ruble from './Ruble'
import rupee from './Rupee'
import shekel from './Shekel'
import won from './Won'
import yen from './Yen'
import yuan from './Yuan'

export {
  dollar,
  euro,
  franc,
  krona,
  lira,
  multiCurrency,
  peso,
  pound,
  ruble,
  rupee,
  shekel,
  won,
  yen,
  yuan
}
